import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

export default function SelectAutoComplete({
  options,
  value,
  onChange,
  fieldC = "label",
  width = 300,
  placeholder = "Selecciona una opción",
  listHeight = "auto",
  label = "",
  ...props
}) {
  return (
    <Autocomplete
      disablePortal
      options={options}
      value={value || null}
      onChange={onChange}
      getOptionLabel={(option) => {
        // Previene errores si option es string o null
        if (!option) return "";
        if (typeof option === "string") return option;
        return option[fieldC] || "";
      }}
      sx={{
        width: width,
        "& .MuiAutocomplete-popupIndicator": {
          color: "#62C776",
        },
        "& .MuiInputBase-input": {
          fontFamily: "Nunito, Arial, sans-serif",
          fontSize: "16px",
          color: "#223D51",
          fontWeight: 600,
        },
        "& .MuiInputBase-input::placeholder": {
          color: "#C3C3C3",
          opacity: 1,
          fontStyle: "italic",
        },
      }}
      slotProps={{
        popper: {
          sx: {
            "& .MuiAutocomplete-option": {
              fontFamily: "Nunito, Arial, sans-serif",
              fontSize: "15px",
              color: "#223D51",
              fontWeight: 500,
              textAlign: "left",
              whiteSpace: "normal",
            },
            "& .MuiAutocomplete-option[aria-selected='true']": {
              backgroundColor: "#62C777",
              color: "#223D51",
              fontWeight: 700,
            },
            "& .MuiAutocomplete-option.Mui-focused": {
              backgroundColor: "#62C777",
              color: "#223D51",
            },
          },
        },
        listbox: {
          sx: {
            maxHeight: listHeight,
            overflowY: "auto",
          },
        },
      }}
      renderInput={(params) => (
        <TextField placeholder={placeholder} {...params} label={label} />
      )}
      {...props}
    />
  );
}
